import React from 'react';

import { detailFacturePath, factureBasePath, listeFacturesPath } from './constants';
import FactureRoot from './views/FactureRoot';
import ListeFactures from './views/liste/ListeFactures';
import DetailFacture from './views/detail/DetailFacture';

export const FactureRouter = {
    path: factureBasePath,
    element: <FactureRoot />,
    children: [
        {
            path: listeFacturesPath,
            element: <ListeFactures />,
        },
        {
            path: detailFacturePath,
            element: <DetailFacture />,
        },
    ],
};
